// public/js/modules/ui/confirm.js
// Promise-based Bootstrap confirm dialog, styled to match the app (dark themed
// modals as used elsewhere). Replaces native window.confirm.
//
//   const ok = await showConfirm({ title, body, confirmText, variant });
//   if (ok) { ... }

export function showConfirm({
  title = 'Are you sure?',
  body = '',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger', // bootstrap colour for the confirm button + accent
  icon = 'fa-triangle-exclamation',
} = {}) {
  return new Promise((resolve) => {
    const id = `confirm-${Math.random().toString(36).slice(2)}`;
    const html = `
      <div class="modal fade" id="${id}" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content bg-dark text-white border-${variant}">
            <div class="modal-header border-${variant}">
              <h5 class="modal-title"><i class="fa-solid ${icon} text-${variant} me-2"></i>${title}</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">${body}</div>
            <div class="modal-footer border-${variant}">
              <button type="button" class="btn btn-secondary js-confirm-cancel" data-bs-dismiss="modal">${cancelText}</button>
              <button type="button" class="btn btn-${variant} js-confirm-ok">${confirmText}</button>
            </div>
          </div>
        </div>
      </div>`;

    document.body.insertAdjacentHTML('beforeend', html);
    const el = document.getElementById(id);
    const modal = new bootstrap.Modal(el);
    let decided = false;

    el.querySelector('.js-confirm-ok').addEventListener('click', () => {
      decided = true;
      modal.hide();
      resolve(true);
    });
    el.addEventListener('hidden.bs.modal', () => {
      el.remove();
      if (!decided) resolve(false);
    }, { once: true });

    modal.show();
  });
}
